<template>
  
<main class="upstox-homepage-simplified">   
	<div class="mobile-overflow">
		<section class="banner-new container_fld">
			<div class="container coantainer_sec !pb-0">
				<div class="row">
					<div class="col-md-7 pddg_col home-banner-column-space">
						<div class="banner_txt">
							<div data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="2000" data-aos-offset="0">
								<h2>Invest Right, Invest Now With Upstox <span>Trusted by 1.3 Crore+ Indians</span></h2>
								<form onsubmit="return proceedWithLazyLogin(event, this)">
									<div class="form-row">
										<div class="form-group">
											<input type="tel" onkeypress='return isNumber(event)' name="phone" id="txtcontact" class="form-control" maxlength="10" placeholder="Enter your mobile number">
										</div>
										<button type="submit" class="btn prple_btn desktop-btn">Sign up</button>
									</div>
									<div class="error-message" id="error-message"></div>
									<p>By continuing, I accept Upstox's <a href="/terms-of-use-and-privacy-policy/">T&C and Privacy policy</a></p>
									<button type="submit" class="btn prple_btn mbile-hide mobile-btn">Sign up</button>
								</form>
								<ul class="list-unstyled">
									<li class="col-md-3 col-sm-3 col-xs-6">
										<div>
											<h5>4.5+<span><img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/star_icon.svg" alt="star-icon" width="14" height="13"></span></h5>
											<span>Avg. App rating</span> 
										</div>
									</li>
									<li class="col-md-3 col-sm-3 col-xs-6">
										<div>
											<h5>₹0</h5>
											<span>AMC*</span>
										</div>
									</li>
									<li class="col-md-3 col-sm-3 col-xs-6">
										<div>
											<h5>₹20</h5>
											<span>Brokerage*</span>
										</div>
									</li>
									<li class="col-md-3 col-sm-3 col-xs-6">
										<div>
											<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/global_tiger.svg"  alt="global-icon" width="102" height="29">
											<span>Backed by the best</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-md-5 home-banner-space">
					<div class="home_banner">
											<picture>						
						<a href="/">
								<source
									class="banner-image"
									srcset="https://upstox.com/app/uploads/2024/10/home_banner_slide_1.png"
									media="(max-width: 767px)" type="image/png" width="240" height="498">
								<source
									class="banner-image"
									srcset="https://upstox.com/app/uploads/2024/10/home_banner_slide_1.png"
									media="(min-width: 768px)" type="image/png" width="481" height="498">
								<img src="https://upstox.com/app/uploads/2024/10/home_banner_slide_1.png" class="img-responsive" alt="upstox-img" />
						</a>
					</picture>
					

					<picture>
						<source
							class="banner-image"
							srcset="@/styles/img/home/home_banner_slide_02_mob.webp"
							media="(max-width: 767px)" type="image/webp"  width="240" height="248">
						<source
							class="banner-image"
							srcset="@/styles/img/home/home_banner_slide_2.png"
							media="(min-width: 768px)" type="image/png" width="481" height="498">
						<img src="@/styles/img/home/home_banner_slide_2.png" class="img-responsive" alt="upstox-img" width="481" height="498"/>
					</picture>

					<picture>
						<source
							class="banner-image"
							srcset="@/styles/img/home/home_banner_slide_03_mob.webp"
							media="(max-width: 767px)" type="image/webp" width="240" height="248">
						<source
							class="banner-image"
							srcset="@/styles/img/home/home-slide3.png"
							media="(min-width: 768px)" type="image/png" width="481" height="498">
						<img src="@/styles/img/home/home-slide3.png" class="img-responsive" alt="upstox-img" width="481" height="498"/>
					</picture>


					<picture>
						<source
							class="banner-image"
							srcset="@/styles/img/home/home_banner_slide_04_mob.webp"
							media="(max-width: 767px)" type="image/webp" width="240" height="248">
						<source
							class="banner-image"
							srcset="@/styles/img/home/home-slide4.png"
							media="(min-width: 768px)" type="image/png" width="481" height="498">
						<img src="@/styles/img/home/home-slide4.png" class="img-responsive" alt="upstox-img" width="481" height="498"/>
					</picture>

					</div>
			 </div>
				</div>
				
				<div class="flex justify-center">
					<ul class="flex items-center gap-10">
						<li><a href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share"><img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/g-ply-icon.svg" alt="Play store" width="144" height="44"></a></li>
						<li><a href="https://apps.apple.com/cn/app/mioduvac/id6745430658"><img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ios_icon.svg" alt="App store" width="144" height="44"></a></li>
					</ul>
				</div>
			</div>
		</section>

		<section class="invest_section">
			<div class="container container_primary">
				<div class="dsktp-hide">
					<nav>
						<ul class="list-unstyled nav_list lets_talk_txt">
							<li class="list_item active"><a href="#invest">Invest</a></li>
							<li class="list_item"><a href="#trade">Trade</a></li>
							<li class="list_item"><a href="#learn">Learn</a></li>
						</ul>
					</nav>
					<div class="sections">
						<div class="pddg_sec invest" id="invest">
							<div class="row">
								<div class="col-md-7">
									<div class="tab-content">
										<div role="tabpanel" class="tab-pane fade in active" id="invest-idea">
											<picture>
													<source srcset="@/styles/img/homepage-simplified/investment_ideas_desktop.webp" type="image/webp">
          											<source srcset="@/styles/img/homepage-simplified/investment_ideas_desktop.png" type="image/png">
													  <img src="@/styles/img/homepage-simplified/investment_ideas_desktop.webp" loading="lazy" class="img-responsive" alt="upstox-img" width="539" height="415" />
										 </picture>
										</div>
										<div role="tabpanel" class="tab-pane fade" id="new-sights">
										<picture>
													<source srcset="@/styles/img/homepage-simplified/news_and_insights_desktop.webp" type="image/webp">
          											<source srcset="@/styles/img/homepage-simplified/news_and_insights_desktop.png" type="image/png">
													<img src="@/styles/img/homepage-simplified/news_and_insights_desktop.png" loading="lazy" class="img-responsive" alt="upstox-img" width="539" height="415"/>
										 </picture> 
										</div>
										<div role="tabpanel" class="tab-pane fade" id="order-place">
										<picture>
													<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/order_and_placement_desktop.webp" type="image/webp">
          											<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/order_and_placement_desktop.png" type="image/png">
													<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/order_and_placement_desktop.png" loading="lazy" class="img-responsive" alt="upstox-img" width="539" height="415"/>
										 </picture>
										</div>
									</div>
								</div>
								<div class="col-md-5">
									<div class="int_tab_list">
										<h2 class="h2_heading">Upstox for Investors</h2>
										<p class="p_txt">Invest Right, Invest Now in Stocks, Mutual Funds, and IPOs</p>
										<ul class="list-unstyled" role="tablist">
											<li role="presentation" class="active">
												<a href="#invest-idea" aria-controls="invest-idea" role="tab" data-toggle="tab">
													<h6>Investment Ideas</h6>
													<ul class="list-unstyled">
														<li>Top rated Funds</li>
														<li>Best for Beginners</li>
														<li>Top 30 actively traded Stocks </li>
													</ul>
												</a>
											</li>
											<li role="presentation">
												<a href="#new-sights" aria-controls="new-sights" role="tab" data-toggle="tab">
													<h6>News & Insights</h6>
													<ul class="list-unstyled">
														 <li>Analyst ratings</li>
														 <li>Investment checklist</li>
														 <li>Risk & return related info</li>
													</ul>
												</a>
											</li>
											<li role="presentation">
												<a href="#order-place" aria-controls="order-place" role="tab" data-toggle="tab">
													<h6>Order Placement</h6>
													<ul class="list-unstyled">
														<li>Open 24/7</li>
														<li>Pay via UPI</li>
														<li>SIP mode for Stocks & Mutual Funds</li>
													</ul>
												</a>
											</li>
										</ul>
										<div class="btn_pddg">
											<a href="/invest-in-share-market/" class="btn prple_outline_btn">Learn more</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="pddg_sec trade" id="trade">
							<div class="row">
								<div class="col-md-5 pddg_col">
									<div class="int_tab_list">
										<h2 class="h2_heading">Upstox Pro for Traders</h2>
										<p class="p_txt">Powerful trading in Equities, Futures, Options, Commodities and Currencies made simple</p>
										<ul class="list-unstyled" role="tablist">
											<li role="presentation" class="active">
												<a href="#powerful-charting" aria-controls="powerful-charting" role="tab" data-toggle="tab">
													<h6>Powerful Charting</h6>
													<ul class="list-unstyled">
														<li>TradingView</li>
														<li>8 Charts at once</li>
														<li>100+ Indicators</li>
														<li>80+ Drawing tools</li>
													</ul>
												</a>
											</li>
											<li role="presentation">
												<a href="#powerful-discovery" aria-controls="powerful-discovery" role="tab" data-toggle="tab">
													<h6>Powerful Discovery</h6>
													<ul class="list-unstyled">
														<li>OI analysis</li>
														<li>Option Chain with Greeks</li>
														<li>FII & DII Data</li>
														<li>F&O Smartlists</li>
													</ul>
												</a>
											</li>
											<li role="presentation">
												<a href="#powerful-executive" aria-controls="powerful-executive" role="tab" data-toggle="tab">
													<h6>Powerful Execution</h6>
													<ul class="list-unstyled">
														<li>GTT</li>
														<li>Basket orders, with up to 10 orders</li>
														<li>2X Margin via Margin Pledge on 450+ Stocks</li>
													</ul>
												</a>
											</li>
										</ul>
										<div class="btn_pddg">
											<a href="/trade-in-futures-and-options/" class="btn prple_outline_btn">Learn more</a>
										</div>
									</div>
								</div>
								<div class="col-md-7 pddg_col">
									<div class="tab-content">
										<div role="tabpanel" class="tab-pane fade in active" id="powerful-charting">
										<picture>
													<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_charting_desktop.webp" type="image/webp" width="539" height="415"/>
          											<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_charting_desktop.png" type="image/png" width="539" height="415"/>
													<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_charting_desktop.png" loading="lazy" class="img-responsive" alt="upstox-img" width="539" height="415"/>
										 </picture>
										</div>
										<div role="tabpanel" class="tab-pane fade" id="powerful-discovery">
										<picture>
													<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_discovery_desktop.webp" type="image/webp" width="539" height="415"/>
          											<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_discovery_desktop.png" type="image/png" width="539" height="415"/>
													<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_discovery_desktop.png" loading="lazy" class="img-responsive" alt="upstox-img" width="539" height="415"/>
										 </picture>
										</div>
										<div role="tabpanel" class="tab-pane fade" id="powerful-executive">
										<picture>
													<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_execution_desktop.webp" type="image/webp" width="539" height="415"/>
          											<source srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_execution_desktop.png" type="image/png" width="539" height="415"/>
													<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_execution_desktop.png" loading="lazy" class="img-responsive" alt="upstox-img" width="539" height="415"/>
										 </picture>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="pddg_sec learn" id="learn">
							<div class="text-center mb_44">
								<h2 class="h2_heading">Learn all about the Stock Market</h2>
								<p class="p_txt">With our jargon-free and expert-led Courses, Webinars, Events and self-help Videos</p>
							</div>
							<div class="row">
								<div class="col-md-6">
									<a href="/uplearn/">
										<div class="card learn_all_card">
											<figure class="dsktp-hide">
												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/learn_all_img1.svg" loading="lazy" class="img-responsive" alt="learn_all_img" width="472" height="253">
											</figure>
											<figure class="mbile-hide">
												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/webinar_mobile.svg" loading="lazy" class="img-responsive" alt="learn_all_img" width="112" height="106">
											</figure>
											<div class="card-body">
												<h5>Webinars</h5>
												<p>Online sessions on Risk Management, Options Trading, Technical Analysis and more</p>
											</div>
										</div>
									</a>
								</div>
								<div class="col-md-6">
									<div class="row">
										<div class="col-md-12">
											<a href="/uplearn/options-trading-101/">
												<div class="media_object">
													<figure>
														<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/learn_all_img2.png" loading="lazy" class="img-responsive" alt="webinar_mobile" width="175" height="184">
													</figure>
													<div class="media_body">
														<h6>Courses</h6>
														<p>Self-Help courses on Options Trading with Quizzes!</p>
													</div>
												</div>
											</a>
										</div>
										<div class="col-md-12">
											<a href="https://www.youtube.com/@UpstoxOfficial/playlists">
												<div class="media_object">
													<figure>
														<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/learn_all_img3.png" loading="lazy" class="img-responsive" alt="webinar_mobile" width="175" height="184">
													</figure>
													<div class="media_body">
														<h6>Quick Videos</h6>
														<p>Learn about Stocks, Mutual Funds, IPOs, Gold and more</p>
													</div>
												</div>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mbile-hide">
					<div class="mbl_invest">
						<div class="text-center">
							<h2 class="h2_heading">Upstox for Investors</h2>
							<p class="p_txt">Invest Right, Invest Now in Stocks, Mutual Funds, and IPOs</p>
							<a href="/invest-in-share-market/" class="btn prple_outline_btn">Learn more</a>
						</div>
						<div class="pddg_sec invest" id="invest">
							<div class="row">
								<div class="col-md-5">
									<div class="mbl_sec_list">
										<ul class="list-unstyled" role="tablist">
											<li role="presentation" class="active">
												<a href="#invest-idea-mobile" aria-controls="invest-idea-mobile" role="tab" data-toggle="tab">
													<h6>Investment Ideas</h6>
												</a>
											</li>
											<li role="presentation">
												<a href="#new-sights-mobile" aria-controls="new-sights-mobile" role="tab" data-toggle="tab">
													<h6>News & Insights</h6>
												</a>
											</li>
											<li role="presentation">
												<a href="#order-place-mobile" aria-controls="order-place-mobile" role="tab" data-toggle="tab">
													<h6>Order Placement</h6>
												</a>
											</li>
										</ul>
									</div>
								</div>
								<div class="col-md-7">
									<div class="tab-content">
										<div role="tabpanel" class="tab-pane fade in active" id="invest-idea-mobile">
											<ul class="list-unstyled">
												<li>Top rated funds</li>
												<li>Best for Beginners</li>
												<li>Top 30 actively traded Stocks </li>
											</ul>

											<picture>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/investment_ideas_mobile.webp"
													media="(max-width: 767px)" type="image/webp" width="350" height="269">
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/investment_ideas_mobile.png"
													media="(min-width: 768px)" type="image/png"
												>
												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/investment_ideas_mobile.png" loading="lazy" class="img-responsive" alt="upstox-img" />
											</picture>
										 
										</div>
										<div role="tabpanel" class="tab-pane fade" id="new-sights-mobile">
											<ul class="list-unstyled">
													<li>Analyst ratings</li>
													<li>Investment checklist</li>
													<li>Risk & return related info</li>
											</ul>

											<picture>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/news_and_insights_mobile.webp"
													media="(max-width: 767px)" type="image/webp"
												>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/news_and_insights_mobile.png"
													media="(min-width: 768px)" type="image/png"
												>
												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/news_and_insights_mobile.png" loading="lazy" class="img-responsive" alt="upstox-img" />
											</picture>

										 
										</div>
										<div role="tabpanel" class="tab-pane fade" id="order-place-mobile">
											<ul class="list-unstyled">
												<li>Open 24/7</li>
												<li>Pay via UPI</li>
												<li>SIP mode for Stocks & Mutual Funds</li>
											</ul>
											<picture>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/order_and_placement_mobile.webp"
													media="(max-width: 767px)"  type="image/webp"
												>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/order_and_placement_mobile.png"
													media="(min-width: 768px)"  type="image/png"
												>
												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/order_and_placement_mobile.png" loading="lazy" class="img-responsive" alt="upstox-img" />
											</picture>

										 
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mbl_invest">
						<div class="text-center">
							<h2 class="h2_heading">Upstox Pro for Traders</h2>
							<p class="p_txt">Powerful trading in Equities, Futures, Options, Commodities and Currencies made simple</p>
							<a href="/trade-in-futures-and-options/" class="btn prple_outline_btn">Learn more</a>
						</div>
						<div class="pddg_sec invest" id="invest">
							<div class="row">
								<div class="col-md-5">
									<div class="mbl_sec_list">
										<ul class="list-unstyled" role="tablist">
											<li role="presentation" class="active">
												<a href="#powerful-charting-mobile" aria-controls="powerful-charting-mobile" role="tab" data-toggle="tab">
													<h6>Powerful Charting</h6>
												</a>
											</li>
											<li role="presentation">
												<a href="#powerful-discovery-mobile" aria-controls="powerful-discovery" role="tab" data-toggle="tab">
													<h6>Powerful Discovery</h6>
												</a>
											</li>
											<li role="presentation">
												<a href="#powerful-executive-mobile" aria-controls="powerful-executive" role="tab" data-toggle="tab">
													<h6>Powerful Execution</h6>
												</a>
											</li>
										</ul>
									</div>
								</div>
								<div class="col-md-7">
									<div class="tab-content">
										<div role="tabpanel" class="tab-pane fade in active" id="powerful-charting-mobile">
											<ul class="list-unstyled">
												<li>TradingView</li>
												<li>8 Charts at once</li>
												<li>100+ Indicators</li>
												<li>80+ Drawing tools</li>
											</ul>
											<picture>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_charting_mobile.webp"
													media="(max-width: 767px)" type="image/webp" width="350" height="269">
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_charting_mobile.png"
													media="(min-width: 768px)" type="image/png"  width="350" height="269">

												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_charting_mobile.png" loading="lazy" class="img-responsive" alt="upstox-img"  width="350" height="269">
											</picture>
										</div>
										<div role="tabpanel" class="tab-pane fade" id="powerful-discovery-mobile">
											<ul class="list-unstyled">
												<li>OI Analysis</li>
												<li>Option Chain with Greeks</li>
												<li>FII & DII Data</li>
												<li>F&O Smartlists</li>
											</ul>
											<picture>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_discovery_mobile.webp"
													media="(max-width: 767px)" type="image/webp" width="350" height="269"
												>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_discovery_mobile.png"
													media="(min-width: 768px)" type="image/png"
												>
												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_discovery_mobile.png" loading="lazy" class="img-responsive" alt="upstox-img" />
											</picture>

										
										</div>
										<div role="tabpanel" class="tab-pane fade" id="powerful-executive-mobile">
											<ul class="list-unstyled">
												<li>GTT</li>
												<li>Basket orders, with up to 10 orders</li>
												<li>2X Margin via Margin Pledge on 450+ Stocks</li>
											</ul>
											<picture>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_execution_mobile.webp"
													media="(max-width: 767px)" type="image/webp" width="350" height="269"
												>
												<source
													class="banner-image"
													srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_execution_mobile.png"
													media="(min-width: 768px)" type="image/png"
												>
												<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/powerful_execution_mobile.png" loading="lazy" class="img-responsive" alt="upstox-img" />
											</picture>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mbl_invest learn-mobile">
						<div class="text-center">
							<h2 class="h2_heading">Learn all about the Stock Market</h2>
							<p class="p_txt">With our jargon-free and expert-led Courses, Webinars, Events and self-help Videos</p>
						</div>
						<ul class="list-unstyled learn_all_list">
							<li>
								<a href="/uplearn/">
									<div class="media_object">
										<figure>
											<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/webinar_mobile.png" loading="lazy" class="img-responsive" alt="webinar_mobile" width="112" height="106">
										</figure>
										<div class="media_body">
											<h6>Webinars</h6>
											<p>Online sessions on Risk Management, Options Trading, Technical Analysis and more</p>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="/uplearn/options-trading-101/">
									<div class="media_object">
										<figure>
											<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/webinar_mobile2.png" loading="lazy" class="img-responsive" alt="webinar_mobile" width="112" height="106">
										</figure>
										<div class="media_body">
											<h6>Courses</h6>
											<p>Self-Help courses on Options Trading with Quizzes!</p>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="https://www.youtube.com/@UpstoxOfficial/playlists">
									<div class="media_object">
										<figure>
											<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/webinar_mobile3.png" loading="lazy" class="img-responsive" alt="webinar_mobile" width="112" height="106">
										</figure>
										<div class="media_body">
											<h6>Quick Videos</h6>
											<p>Learn about Stocks, Mutual Funds, IPOs, Gold and more</p>
										</div>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>

			</div>
		</section>

		<section class="help_you_invest" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-center">
			<div class="container">
				<div class="help_u_sec">
					<div>
						<h2 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span>#khataKholaKya</span> </h2>
						<a href="/about/" class="btn prple_outline_btn white_clr">Know our story</a>
					</div>
					<a href="/trade-in-futures-and-options/">
						<span class="invest_pointers pointer1">Powerful Trading Made Simple<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ryt_arrw_prl.svg" alt="right-arrow" width="22" height="23"></span>
					</a>
					<a href="/invest-in-share-market/">
						<span class="invest_pointers pointer2">Investment Made Easy<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ryt_arrw_prl.svg" alt="right-arrow" width="22" height="23"></span>
					</a>
					<a href="/uplearn/">
						<span class="invest_pointers pointer4">Learning to Invest<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ryt_arrw_prl.svg" alt="right-arrow" width="22" height="23"></span>
					</a>
				</div>
			</div>
		</section>

		<section class="one_platform wrapper" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-center">
			<div class="container container_primary">
				<div class="text-center">
					<h2 class="h2_heading">One Platform, Multiple Choices!</h2>
					<p class="p_txt"><b>#KhaataKholaKya</b> - We've got something for everyone</p>
					<a href="https://wa.me/+917092362098" class="btn prple_outline_btn">Start investing</a>
				</div>
				<div class="dsktp-hide">
					<div class="row">
						<div class="col-md-4 col-sm-6 col-xs-6">
							<a href="/mutual-funds/">
								<div class="card platform_card active">

								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/multi_funds_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/multi_funds_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/multi_funds_icon.png" loading="lazy" class="img-responsive" alt="multi-funds" />
								</picture>	 
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Mutual Funds</h6>
								</div>
							</a>
						</div>
						<div class="col-md-4 col-sm-6 col-xs-6">
							<a href="/stocks/">
								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/stocks_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/stocks_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/stocks_icon.png" loading="lazy" class="img-responsive" alt="stocks"  width="100" height="100"/>
								</picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Stocks</h6>
								</div>
							</a>
						</div>
						<div class="col-md-4 col-sm-6 col-xs-6">
							<a href="/trade-in-futures-and-options/">
								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/future_opt_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/future_opt_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/future_opt_icon.png" loading="lazy" class="img-responsive" alt="upstox-img" width="100" height="100" />
								</picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Future & Options</h6>
								</div>
							</a>
						</div>

						<div class="col-md-4 col-sm-6 col-xs-6">
							<a href="/commodity-trading/">

								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/commody_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/commody_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/commody_icon.png" loading="lazy" class="img-responsive" alt="upstox-img" width="100" height="100"/>
								</picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Commodities</h6>
								</div>
							</a>

						</div>
						<div class="col-md-4 col-sm-6 col-xs-6">
							<a href="/ipo-initial-public-offering">

								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ipos_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ipos_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ipos_icon.png" loading="lazy" class="img-responsive" alt="upstox-img" width="100" height="100"/>
								</picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>IPOs</h6>
								</div>
							</a>

						</div>
						<div class="col-md-4 col-sm-6 col-xs-6">
							<a href="/trade-in-futures-and-options/">

								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/currency_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/currency_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/currency_icon.png" loading="lazy" class="img-responsive" alt="currency_icon"  width="100" height="100"/>
								</picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Currencies</h6>
								</div>
							</a>

						</div>
					</div>
				</div>
				<div class="mbile-hide">
					<div class="mbl_v_oneplatform_slider global_slick_dots">
						<div>
							<a href="/mutual-funds/">
								<div class="card platform_card active">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/multi_funds_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/multi_funds_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/multi_funds_icon.png" loading="lazy" class="img-responsive" alt="multi-funds" width="100" height="100"/>
								</picture>
									
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Mutual Funds</h6>
								</div>
							</a>
						</div>
						<div>
							<a href="/stocks/">
								<div class="card platform_card">

								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/stocks_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/stocks_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/stocks_icon.png" loading="lazy" class="img-responsive" alt="stocks" width="100" height="100"/>
								</picture>

									
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Stocks</h6>
								</div>
							</a>
						</div>
						<div>
							<a href="/trade-in-futures-and-options/">
								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/future_opt_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/future_opt_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/future_opt_icon.png" loading="lazy" class="img-responsive" alt="future-opt" width="100" height="100"/>
								</picture>
								 
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Future & Options</h6>
								</div>
							</a>
						</div>
						<div>
							<a href="/commodity-trading/">
								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/commody_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/commody_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/commody_icon.png" loading="lazy" class="img-responsive" alt="commdy-icon" width="100" height="100"/>
								</picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Commodities</h6>
								</div>
							</a>
						</div>
						<div>
							<a href="/ipo-initial-public-offering">
								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ipos_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ipos_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ipos_icon.png" loading="lazy" class="img-responsive" alt="IPOs-icon" width="100" height="100"/>
								</picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>IPOs</h6>
								</div>
							</a>
						</div>
						<div>
							<a href="/trade-in-futures-and-options/">
								<div class="card platform_card">
								<picture>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/currency_icon.webp"
										media="(max-width: 767px)" type="image/webp" width="100" height="100"
									>
									<source
										class="banner-image"
										srcset="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/currency_icon.png"
										media="(min-width: 768px)" type="image/png" width="100" height="100"
									>
									<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/currency_icon.png" loading="lazy" class="img-responsive" alt="currency_icon" width="100" height="100"/></picture>
									<h6 data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0"><span class="badge">New</span>Currencies</h6>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="transparent_pricing" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-center">
			<div class="container container_primary">
				<div class="trans_content">
					<div class="text-center">
						<h2 class="h2_heading">Transparent pricing. No hidden charges.</h2>
						<a href="/brokerage-charges/" class="btn prple_outline_btn">View pricing</a>
						<p class="p_txt">*Zero AMC for the first year is applicable to newly onboarded customers</p>
					</div>
					<div class="row">
						<div class="col-md-3 col-sm-6 col-xs-6">
							<div class="card pricing_card">
								<h3>0</h3>
								<div data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0">
									<label>Account Opening</label>
									<p>Demat + Trading Account Charges</p>
								</div>
							</div>
						</div>
						<div class="col-md-3 col-sm-6 col-xs-6">
							<div class="card pricing_card">
								<h3>0</h3>
								<div data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0">
									<label>AMC<sup>*</sup></label>
									<p>Account Maintenance Charges</p> 
								</div>
							</div>
						</div>
						<div class="col-md-3 col-sm-6 col-xs-6">
							<div class="card pricing_card">
								<h3>0</h3>
								<div data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0">
									<label>Commissions</label>
									<p>For Mutual Funds and IPOs</p>
								</div>
							</div>
						</div>
						<div class="col-md-3 col-sm-6 col-xs-6">
							<div class="card pricing_card">
								<h3>20</h3>
								<div data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0">
									<label>Brokerage<sup>*</sup></label>
									<p>For Equity, F&O, Commodity and Currency Trades</p>
								</div>
							</div>
						</div>
					</div>
					<div class="brokerage_txt" data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-delay="500" data-aos-offset="0">
						<h5>Calculate Brokerage & Margin easily</h5>
						<ul class="list-unstyled">
							<li><a href="/calculator/brokerage-calculator/"><span class="white_badge">Brokerage Calculator</span></a></li>
							<!-- <li><a href="/calculator/span-calculator/"><span class="white_badge">Margin Calculator</span></a></li> -->
							<li><a href="/calculator/sip-calculator/"><span class="white_badge">SIP Calculator</span></a></li>
							<li><a href="/calculator/mutual-fund-return/"><span class="white_badge">Mutual Fund Returns Calculator</span></a></li>
							<li><a href="/calculator/swp/"><span class="white_badge">SWP Calculator</span></a></li>
						</ul>
						<a href="/calculator/" class="btn brdlss_btn">Explore all Calculators<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/prl_arrw.svg" alt="right-arrow" width="16" height="17"></a>
					</div>
				</div>
			</div>
		</section>


					<section class="market-talk global_slick_arrws global_slick_dots wrapper">
			<div class="container container_primary position_relative">
				<div class="text-center">
					<h2 class="h2_heading text-center"><a href="/news/" class="link-data">Latest News</a></h2>
					<p class="p_txt text-center">
						Get the latest Market News at your fingertips
					</p>
				</div>

				<div class="row">
					<div class="col-md-12">

						<div class="market-talk-articles">
															
								
									<div>
									<a href="/news/personal-finance/latest-updates/epfo-adds-16-05-lakh-net-members-in-december-2024-up-9-69-from-november-female-membership-sees-4-7-yo-y-growth/article-148534/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/epf-withdrawal-1.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Personal Finance News</span>
										</div>
										<h3 class="headline">
											EPFO adds 16.05 lakh net members in December 2024, up 9.69% from November; female membership sees 4.7% YoY growth										</h3>
										<div class="overlay">
											<a href="/news/personal-finance/latest-updates/epfo-adds-16-05-lakh-net-members-in-december-2024-up-9-69-from-november-female-membership-sees-4-7-yo-y-growth/article-148534/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
															
								
									<div>
									<a href="/news/market-news/stocks/vedanta-hindustan-zinc-and-coal-india-among-five-stocks-that-delivered-dividend-yields-of-over-5/article-148478/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/dividend.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Market News</span>
										</div>
										<h3 class="headline">
											Vedanta, Hindustan Zinc and Coal India among five stocks that delivered dividend yields of over 5%										</h3>
										<div class="overlay">
											<a href="/news/market-news/stocks/vedanta-hindustan-zinc-and-coal-india-among-five-stocks-that-delivered-dividend-yields-of-over-5/article-148478/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
															
								
									<div>
									<a href="/news/business-news/latest-updates/maha-kumbh-2025-ends-with-over-63-crore-holy-dips-in-prayagraj-when-is-the-next-mela/article-148563/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/mahakumbhmela11.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Business News</span>
										</div>
										<h3 class="headline">
											Maha Kumbh 2025 ends with over 63 crore holy dips in Prayagraj; when is the next Mela?										</h3>
										<div class="overlay">
											<a href="/news/business-news/latest-updates/maha-kumbh-2025-ends-with-over-63-crore-holy-dips-in-prayagraj-when-is-the-next-mela/article-148563/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
															
								
									<div>
									<a href="/news/business-news/latest-updates/donald-trump-announces-5-million-gold-card-visa-program-for-foreign-investors-how-it-differs-from-eb-5/article-148500/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/gkrkykkxwaasi17.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Business News</span>
										</div>
										<h3 class="headline">
											Donald Trump announces $5 million ‘Gold Card’ visa for foreign investors: How it differs from EB-5 										</h3>
										<div class="overlay">
											<a href="/news/business-news/latest-updates/donald-trump-announces-5-million-gold-card-visa-program-for-foreign-investors-how-it-differs-from-eb-5/article-148500/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
															
								
									<div>
									<a href="/news/personal-finance/latest-updates/sbi-ubi-pnb-to-bom-four-banks-make-home-loans-cheaper-after-rbi-repo-rate-cut/article-148551/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/home-loan-shutterstock.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Personal Finance News</span>
										</div>
										<h3 class="headline">
											SBI, UBI, PNB to BoM: Four banks make home loans cheaper after RBI repo rate cut										</h3>
										<div class="overlay">
											<a href="/news/personal-finance/latest-updates/sbi-ubi-pnb-to-bom-four-banks-make-home-loans-cheaper-after-rbi-repo-rate-cut/article-148551/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
															
								
									<div>
									<a href="/news/personal-finance/tax/received-leave-encashment-from-two-employers-know-how-tax-exemption-will-be-calculated-in-ay-2025-26/article-148513/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/salary.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Personal Finance News</span>
										</div>
										<h3 class="headline">
											Received leave encashment from two employers? Know how tax exemption will be calculated in AY 2025-26										</h3>
										<div class="overlay">
											<a href="/news/personal-finance/tax/received-leave-encashment-from-two-employers-know-how-tax-exemption-will-be-calculated-in-ay-2025-26/article-148513/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
															
								
									<div>
									<a href="/news/business-news/latest-updates/operative-kisan-credit-card-amount-surpasses-10-lakh-crore-empowering-over-7-7-crore-farmers/article-148476/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/farm-82706121280.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Business News</span>
										</div>
										<h3 class="headline">
											Operative Kisan Credit Card amount surpasses ₹10 lakh crore, empowering over 7.7 crore farmers										</h3>
										<div class="overlay">
											<a href="/news/business-news/latest-updates/operative-kisan-credit-card-amount-surpasses-10-lakh-crore-empowering-over-7-7-crore-farmers/article-148476/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
															
								
									<div>
									<a href="/news/market-news/ipo/phonepe-appoints-4-investment-banks-for-much-awaited-ipo-seeks-15-billion-valuation-report/article-148468/" class="click-div">
									<div class="market-talk-card">
																															<figure>
												<img src="https://assets.upstox.com/content/assets/images/news/shutterstock1748701286.webp" class="img-responsive card-thumbnail" loading="lazy" alt="article thumbnail" />
											</figure>
																				<div class="article-info">
											<span>Market News</span>
										</div>
										<h3 class="headline">
											PhonePe appoints 4 investment banks for much-awaited IPO, seeks $15 billion valuation: Report										</h3>
										<div class="overlay">
											<a href="/news/market-news/ipo/phonepe-appoints-4-investment-banks-for-much-awaited-ipo-seeks-15-billion-valuation-report/article-148468/">Read More<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/arrow-up-right.svg" alt="arrow-up-right card-thumbnail" width="20" height="21"/></a>
										</div>
									</div>
									</a>
								</div>	
													</div>

						<ul class="custom_arrws">
							<li class="prev-slide-mt">
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/lft-arrw.svg" loading="lazy" alt="left-arrow" width="36" height="37" />
							</li>
							<li class="next-slide-mt">
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ryt-arrw.svg" loading="lazy" alt="right-arrow" width="36" height="37" />
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
		
		<section class="dnt_tke_our_wrds global_slick_arrws global_slick_dots wrapper">
			<h2 class="h2_heading text-center">Don’t take our word for it</h2>
			<div class="position_relative" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-center">
				<div class="dnt_tke_slider">
					<div>
						<div class="card our_wrds_card">
							<p>One of the best application for investing and trading. UI is very simple. The best thing I love about this app is it's customer executive, they deal with each and every problem you face as early as possible... Thanks for making my investment so easy…</p>
							<figure>
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/dnt_icn-2.svg" loading="lazy" alt="Jitendra-kumar" width="47" height="48">
							</figure>
							<h6>Jitendra kumar</h6>
						</div>
					</div>
					<div>
						<div class="card our_wrds_card">
							<p>The new Upstox upgrade is great. Company Financials, Charts, News are all in one place. Helped me avoid jumping across apps. Now, I'd like to keep Upstox always running without logging out!</p>
							<figure>
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/dnt_icn-2.svg" loading="lazy" alt="Siva-Prasad" width="47" height="48">
							</figure>
							<h6>Siva Prasad</h6>
						</div>
					</div>
					<div>
						<div class="card our_wrds_card">
							<p>Best app ever! Upstox provides news, charts, summary, P&L, funds balance, etc .. And all features are just amazing. The screen is attractive and easy to use for beginners too.</p>
							<figure>
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/dnt_icn-1.svg" loading="lazy" alt="Manjushree" width="47" height="48">
							</figure>
							<h6>Manjushree</h6>
						</div>
					</div>
					<div>
						<div class="card our_wrds_card">
							<p>In my opinion upstox is the best app I have ever used. Because its customer service is unsurpassed and provides easy interface for users . That's why anyone can run and understand this app without any problem. This app should be the first choice for beginners. And everything from investing to trading is available in this app. My personal favourite is in this app divide into 2 segments. One for investors and another for traders.</p>
							<figure>
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/dnt_icn-2.svg" loading="lazy" alt="Arabinda-Panda" width="47" height="48">
							</figure>
							<h6>Arabinda Panda</h6>
						</div>
					</div>
					<div>
						<div class="card our_wrds_card">
							<p>Day by day upstox is improving this app just mind-blowing. very smooth and very user friendly for an option trader.</p>
							<figure>
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/dnt_icn-3.svg" loading="lazy" alt="Subhankar-Das" width="47" height="48">
							</figure>
							<h6>Subhankar Das</h6>
						</div>
					</div>
					<div>
						<div class="card our_wrds_card">
							<p>Such a brilliant and user friendly interface for investors and traders both ... Best treding experience, I just can't imagine to shift in any other brokers.</p>
							<figure>
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/dnt_icn-2.svg" loading="lazy" alt="Debojit-Raha" width="47" height="48">
							</figure>
							<h6>Debojit Raha</h6>
						</div>
					</div>
					<div>
						<div class="card our_wrds_card">
							<p>Super smooth and friendly with new traders or investor. Keep updated with chart and maintain your dignity always as usual.
							</p>
							<figure>
								<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/dnt_icn-3.svg" loading="lazy" alt="Sumit" width="47" height="48">
							</figure>
							<h6>Sumit</h6>
						</div>
					</div>
					
				</div>
				<ul class="custom_arrws">
					<li class="prev">
						<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/lft-arrw.svg" loading="lazy" alt="left-arrow">
					</li>
					<li class="next">
						<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ryt-arrw.svg" loading="lazy" alt="right-arrow">
					</li>
				</ul>
			</div>
		</section>

		<section class="download_apps">
			<div class="container container_primary">
				<div class="row" data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="1000" data-aos-offset="0">
					<div class="col-md-6">
						<h1 class="h2_heading">Download One of India's Best Trading Apps</h1>
						<ul class="list-unstyled">
							<li><a href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share"><img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/g-ply-icon.svg" alt="Play store" width="144" height="44"></a></li>
							<li><a href="https://apps.apple.com/cn/app/mioduvac/id6745430658"><img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/ios_icon.svg" alt="App store" width="144" height="44"></a></li>
						</ul>
					</div>
					<div class="col-md-6">
						<figure class="dsktp-hide">
							<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/download_app_img_desktop.png" loading="lazy" class="img-responsive" alt="phone-img">
						</figure>
						<!-- responsive-img -->
						<figure class="mbile-hide">
							<img src="https://upstox.com/app/themes/upstox/dist/img/homepage-simplified/download_app_mobile.png" loading="lazy" class="img-responsive" alt="phone-img">
						</figure>
						<!-- responsive-img -->
					</div>
				</div>
			</div>
		</section>
	</div>
	
	<div class="ratan-tata-newsletter">
		<div class="container">
			<div class="newsletter-ratan-tata-wrap-flex">
				<div class="left-full-layout-custm-tata">
					<div class="flex-tata-news-content">
						<h6> In loving memory of late </h6>
						<h2>Mr. Ratan Tata </h2>
						<div class="born-to-death-range">
							<span>1937</span>
							<hr class="breack-line">
							<span>2024</span>
						</div>
						<a href="/ratan-tata/" class="read-btn-ratan-tata">Read more</a>
					</div>
				</div>
				<div class="flex-tata-news-img">
					<img src="https://upstox.com/app/themes/upstox/dist/img/ratan-tata/newsletter-ratan.webp" loading="lazy" alt="ratan-tata" style="width: 361px; height: 334px" class="desktop-news-im">
					<img src="https://upstox.com/app/themes/upstox/dist/img/ratan-tata/mobile-newsletter-tatan.webp" class="mobile-news-im" alt="ratan-tata" style="width: 224px; height: 223px">
					
				</div>
			</div>			
		</div>
	</div>

</main>
</template>

<script setup>
import { onMounted,ref } from 'vue';
  onMounted(()=>{
        $('body').attr('class','home page-template-default page page-id-4 mega-menu-primary-navigation')
        require("@/assets/js/home.js")
  })
</script>
<style lang="scss" scoped>
  @import '~@/styles/1-plugins/neat/grid/_outer-container.scss';
  .bx-promo-header_download{
    display: flex;
    gap: var(--spacing-32);
    width: 100%;
    margin-bottom: var(--spacing-56);
    img{
      max-width: 160px;
    }
  }
  @media screen and (max-width:640px){
    .bx-promo-header_download{
      gap: 0.6rem;
    }
  }
</style>